import { TransformedUseCase } from '@repo/editor/src/types';

export function getUseCasesFromData(
  allCategoriesAndUseCases: TransformedUseCase[]
) {
  return allCategoriesAndUseCases
    .filter((category) => !category.hidden)
    .flatMap(
      (category) =>
        category.subCategories?.flatMap(
          (subCategory) =>
            subCategory.useCases?.filter((useCase) => !useCase?.hidden) || []
        ) || []
    );
}

export function findUseCase(
  allCategoriesAndUseCases: TransformedUseCase[],
  useCase: string
) {
  const allUseCases = getUseCasesFromData(allCategoriesAndUseCases);

  const currentUseCaseData = allUseCases.find((uc) => uc.slug === useCase);
  return currentUseCaseData;
}

export function findSubUseCase(
  useCase: TransformedUseCase,
  subUseCase: string
) {
  return useCase.subUseCases?.find((x) => x.shortName === subUseCase);
}

export function buildUseCasePath(
  useCase?: string,
  subUseCase?: string
): string {
  let path = '';
  if (useCase) {
    path += `/${useCase}`;

    if (subUseCase) {
      path += `/${subUseCase}`;
    }
  }

  return path;
}
